/* Chat Script */
loadScriptCMM("https://widget.rake.ai/js/widget.js", null, null, () => {
    var widget = new (window as any).RakeLiveChatWidget("wwc_201245_1562711230487");
});

/* Site-Wide Banner */
deferJQuery(function() {
	headerBannerMultipleColumns([{
    text: "<a style='font-weight:600;' href='/more-products-services/products/window-covering-overview'>Window Coverings</a>, <a style='font-weight:600;' href='/more-products-services/products/custom-draperies--panels-and-hardware'>Drapery</a>, <a style='font-weight:600;' href='/more-products-services/products/wallpaper'>Wallpaper</a>, <a style='font-weight:600;' href='/more-products-services/services/new-home-construction'>New Home Construction</a>",
    bgColor: "",
    txtColor: "#fff",
    linkColor: "#fff",
    border: "0",
    column_min_width: "50%",
    classname: ""
   }, {
    text: "<h2>Request a Consulation <a class='cmm-button cmm-button-hd-colors' href='tel:+16306070993'>(630) 607-0993</a> <a target='_blank' class='cmm-button cmm-button-inverse' href='http://www.google.com/maps/search/?api=1&query=Fresh+Twist+132+N+York+St+Ste+B%2CElmhurst%2CIL+60126-3079'>Directions</a></h2><h4>Proudly serving Elmhurst, Illinois (IL) and the surrounding areas</h4>",
    bgColor: "#fafafa",
    txtColor: "#000",
    border: "0",
    padding: "1rem 0 1rem",
    classname: "",
  }], {
    padding: "1rem 0 0",
    border: {
    border_bottom: "1px solid #ddd",
	},
    column_min_width: "100%",
    classname: "cmm-header-banner-fullwidth"
  });
});
/* Custom Event Tracking */
cmmSetupEventTracking([{selector:'.cmp-navigation__item a[href="/request-consultation"]', action: 'Request Consultation - Menu', event: 'click'}])

/* Custom Metadata */
cmmUpdateMetadata({
    'hunter-douglas/wood-metal-blinds': {
        t: 'Window Blinds, Wooden Blinds, Faux Wood Blinds, Wooden Window Blinds, and Blackout Blinds at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Window Blinds, Wooden Blinds, Faux Wood Blinds, Wooden Window Blinds, and Blackout Blinds near Elmhurst, Rover Forest, Western Springs, and Glen Ellyn, Illinois',
    },
    'hunter-douglas/roman-shades': {
        t: 'Roman Shades, Roman Blinds, and Blackout Roman Shades at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Roman Shades, Roman Blinds, and Blackout Roman Shades at Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/sheers-shadings': {
        t: 'Sheers and Window Shades at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Sheers and Window Shades at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/cellular-honeycomb-shades': {
        t: 'Cellular Shades, Honeycomb Blinds, Cellular Blinds, Honeycomb Shades, and Honeycomb Blinds at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Cellular Shades, Honeycomb Blinds, Cellular Blinds, Honeycomb Shades, and Honeycomb Blinds near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, Illinois',
    },
    'hunter-douglas/roller-shades-solar-shades': {
        t: 'Roller Shades, Solar Shades, and Roller Blinds at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Roller Shades, Solar Shades, and Roller Blinds at Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/woven-woods': {
        t: 'Woven Wood Shades, Woven Shades, Woven Blinds, and Woven Wood Blinds at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Woven Wood Shades, Woven Shades, Woven Blinds, and Woven Wood Blinds near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/shutters': {
        t: 'Window Shutters and Plantation Shutters at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Window Shutters and Plantation Shutters at Hunter Douglas Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/vertical-blinds': {
        t: 'Vertical Window Blinds and Vertical Blinds for Patio Doors at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Vertical Window Blinds and Vertical Blinds for Patio Doors near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },
    'hunter-douglas/side-panels-drapery': {
        t: 'Window Curtains, Drapes, Curtain Sheers, and Black Curtain at Hunter Douglas Store Fresh Twist near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, IL',
        d: 'Window Curtains, Drapes, Curtain Sheers, and Black Curtain near Elmhurst, Rover Forest, Western Springs, Glen Ellyn, and Clarendon Hills, Illinois',
    },    
});